import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import floatingMenu from 'styles/floatingMenu'

export const Modal = styled(Flex)`
  transition: 0.25s;
  overflow-y: auto;
  ${floatingMenu}
`
